import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M8 .526c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8m.42 4.888a.4.4 0 0 1 .322-.273l.897-.13.402-.814c.134-.272.583-.272.717 0l.401.814.898.13a.399.399 0 0 1 .22.683l-.649.633.154.893a.4.4 0 0 1-.58.421L10.4 7.35l-.803.421a.4.4 0 0 1-.58-.422l.153-.892-.65-.633a.4.4 0 0 1-.1-.41m-4.8 0a.4.4 0 0 1 .322-.272l.898-.131.402-.813c.134-.272.583-.272.716 0l.402.813.898.13a.399.399 0 0 1 .22.683l-.65.633.154.893a.4.4 0 0 1-.58.421L5.6 7.35l-.803.421a.4.4 0 0 1-.58-.422l.153-.892-.65-.633a.4.4 0 0 1-.1-.41M8 13.326c-2.438 0-4.4-2.188-4.4-4h.8c.154.153 1.509.466 3.6.466s3.446-.313 3.62-.538l.78.072c0 1.812-1.962 4-4.4 4"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }